import { cn } from '@/utils/classnames';
import { useMemo } from 'react';

interface BadgeProps {
  /** 显示的数量 */
  count: number;
  className?: string;
}

export function Badge({ count, className }: BadgeProps) {
  const display = useMemo(() => count > 99 ? '99+' : count, [count]);
  const isSingle = useMemo(() => count < 10, [count]);
  return (
    <div
      className={cn(
        '[text-shadow:none] absolute z-10 top-[-2px] right-[-2px] flex items-center justify-center bg-accent-red text-white text-[11px] rounded-full pointer-events-none',
        isSingle ? 'w-[13px] h-[13px]' : 'px-[3px] min-w-[13px] h-[13px]',
        className,
      )}
    >
      {display}
    </div>
  );
}
